<!-- eslint-disable vue/no-template-shadow -->
<!-- eslint-disable vue/no-v-html -->
<template>
    <div v-if="productData" class="">
        <div class="border-top">
            <div v-if="!print" class="p-2 text-center" role="radiogroup" :aria-label="$t('step2.selectAreaOfCover')">
                <h5 class="text-center form-section__title">
                    <span v-for="(item, index) in $root.t('step2.selectAreaOfCover')" :key="index">
                        {{ item }} <br />
                    </span>
                </h5>
                <div class="d-flex justify-content-center" style="flex-wrap: wrap">
                    <div v-for="(item, index) in productData.areasOfCover" :key="index">
                        <input
                            :id="'area-selected-' + item.areaOfCoverID + index"
                            type="radio"
                            :name="'area-selected-' + item.areaOfCoverID + index"
                            class="btn-check"
                            :class="[item.areaOfCoverID === $formData.product.areaId ? 'btn-primary' : 'btn-light']"
                            :checked="item.areaOfCoverID === $formData.product.areaId ? true : false"
                            @click="selectArea(index, item.areaOfCoverID)"
                        />
                        <label
                            class="btn m-1 fs-15px"
                            :for="'area-selected-' + item.areaOfCoverID + index"
                            :class="[
                                item.areaOfCoverID === $formData.product.areaId ? 'btn-primary text-light fw-bold' : '',
                            ]"
                            style="border-color: #1076bc"
                        >
                            <span>{{ item.areaOfCoverName }}</span>
                            <span v-if="currentLocale != 'en'">
                                <br />
                                {{ item.areaOfCoverNameTranslation }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
            <h5 v-else class="p-2 text-center">{{ $t('step2.area') }} {{ getAreaPrint() }}</h5>
        </div>

        <!-- package -->
        <div
            v-if="!print"
            role="radiogroup"
            :aria-label="$t('step2.selectPaymentFrequency')"
            class="p-2 text-center mb-5"
        >
            <h5 class="text-center form-section__title">
                <span v-for="(item, index) in $root.t('step2.selectPaymentFrequency')" :key="index">
                    {{ item }}
                    <i
                        class="fa fa-question-circle border-0"
                        aria-hidden="true"
                        style="size: 10px"
                        data-bs-toggle="tooltip"
                        title="Payment Frequency"
                        @click="showPaymentFrequency()"
                    />
                    <br />
                </span>
            </h5>
            <div class="d-flex justify-content-center" style="flex-wrap: wrap">
                <div v-for="(item, index) in productData.paymentFrequencies" :key="index">
                    <input
                        :id="'frequency-selected-' + item.paymentFrequencyID + index"
                        type="radio"
                        :name="'frequency-selected-' + item.paymentFrequencyID + index"
                        class="btn-check"
                        :class="[
                            item.paymentFrequencyID === $formData.product.frequencyId ? 'btn-primary' : 'btn-light',
                        ]"
                        :checked="item.paymentFrequencyID === $formData.product.frequencyId ? true : false"
                        @click="selectFrenquency(item.paymentFrequencyID, item)"
                    />
                    <label
                        class="btn m-1 fs-15px"
                        :for="'frequency-selected-' + item.paymentFrequencyID + index"
                        :class="[
                            item.paymentFrequencyID === $formData.product.frequencyId
                                ? 'btn-primary text-light fw-bold'
                                : '',
                        ]"
                        style="border-color: #1076bc"
                    >
                        <span>
                            {{ item.paymentFrequencyName }}
                            <br />
                            {{
                                item.paymentFrequencyDivideBy == 0
                                    ? item.paymentFrequencyDivideBy + 1
                                    : item.paymentFrequencyDivideBy
                            }}
                            payments per year
                            <br />
                            {{ item.paymentFrequencyChargePercent }}% surcharge
                        </span>
                        <span v-if="currentLocale != 'en'">
                            <br />
                            {{ item.paymentFrequencyNameTranslation }}
                            <br />
                            {{
                                item.paymentFrequencyDivideBy == 0
                                    ? item.paymentFrequencyDivideBy + 1
                                    : item.paymentFrequencyDivideBy
                            }}
                            payments per year
                            <br />
                            {{ item.paymentFrequencyChargePercent }}% surcharge
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <h5 v-else class="p-2 text-center mb-5">{{ $t('step2.frequency') }} {{ getFrequencyPrint() }}</h5>

        <div v-if="requestedCurrencyUnavailableForProduct" class="p-2 text-center alert alert-warning">
            <i class="fas fa-exclamation" /> {{ $t('step2.productNotAvailable') }}
            {{ getCurrency().code }}
        </div>

        <div v-if="requestedCurrencyUnavailableForProduct">
            <br />
            <br />
        </div>

        <h5 class="text-center form-section__title">
            <span v-for="(item, index) in $root.t('step2.selectLevelOfCover')" :key="index"> {{ item }} <br /> </span>
        </h5>
        <br />
        <br />

        <ul
            v-if="levelsOfCover.length > 0"
            role="list"
            :aria-label="$t('step2.selectLevelOfCover')"
            class="d-flex justify-content-between fs-15px list-unstyled"
            style="flex-wrap: wrap"
        >
            <!-- Each level of cover -->
            <li
                v-for="(service, index) in levelsOfCover"
                :key="index"
                class="w-sm-100 service-item mx-auto flex-column"
                tabindex="0"
                :class="{ active: index == levelOfCoverIndex }"
                @click="selectLevelOfCover(index)"
                @keyup.enter="selectLevelOfCover(index)"
            >
                <div class="bg-light h-100 pb-3 px-3">
                    <div class="pt-3 text-center w-100 fs-20px form-section__group" href="#">
                        <strong>{{ service.levelOfCoverName }}</strong>
                        <strong v-if="currentLocale != 'en'">
                            <br />
                            {{ service.levelOfCoverNameTranslation }}
                        </strong>
                    </div>

                    <div class="text-center form-section__field">
                        <div class="service-price text-primary">
                            {{ getCurrency().symbol }}
                            {{
                                Number(
                                    getPremium(
                                        service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency,
                                    ),
                                ).toLocaleString('en-GB', { minimumFractionDigits: 2 })
                            }}
                        </div>
                        <ul style="font-size: 10pt" class="fst-italic list-unstyled">
                            <!-- <span v-for="(item, index) in $root.t('step2.excludingTax')" :key="index">
                                ({{ item }}) <br />
                            </span> -->
                            <li>
                                Premium :
                                {{ getCurrency().symbol }}
                                {{
                                    Number(
                                        getPremiumEx(service, 'basePremiumDividedByPaymentFrequencyAmount'),
                                    ).toLocaleString('en-GB', { minimumFractionDigits: 2 })
                                }}
                            </li>
                            <li v-if="!isVatTheOnlyTaxApplied(service) && getPremiumEx(service, 'taxDividedByPaymentFrequencyAmount') != 0">
                                Tax :
                                {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumEx(service, 'taxDividedByPaymentFrequencyAmount')).toLocaleString(
                                        'en-GB',
                                        { minimumFractionDigits: 2 },
                                    )
                                }}
                            </li>
                            <li>
                                Surcharge : {{ getCurrency().symbol }}
                                {{
                                    Number(
                                        getPremiumEx(service, 'paymentFrequencyAmountDividedByPaymentFrequencyAmount'),
                                    ).toLocaleString('en-GB', { minimumFractionDigits: 2 })
                                }}
                            </li>
                            <!-- <li v-if="getPremiumEx(service, 'taxDividedByPaymentFrequencyAmount') != 0">
                                VAT : {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumEx(service, 'taxDividedByPaymentFrequencyAmount')).toLocaleString(
                                        'en-GB',
                                        { minimumFractionDigits: 2 },
                                    )
                                }}
                            </li> -->
                            <li v-if="isVatApplied(service)">
                                VAT : {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumEx(service, 'taxDividedByPaymentFrequencyAmount')).toLocaleString(
                                        'en-GB',
                                        { minimumFractionDigits: 2 },
                                    )
                                }}
                            </li>                       
                            <!-- <li
                                v-if="getPremiumEx(service, 'invoices') && getPremiumEx(service, 'invoices').length > 0"
                            >
                                Total : {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumEx(service, 'invoices[0]')).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li>
                            <li v-else>
                                Total : {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumEx(service, 'invoices[1]')).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li> -->
                            <li
                                v-if="areThereInvoices(service) && getSecondInvoiceAmount(service) > 0"
                            >
                                First Invoice : {{ getCurrency().symbol }}
                                {{
                                    Number(getFirstInvoiceAmount(service)).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li>
                            <li
                                v-else
                            >
                                Annual Invoice : {{ getCurrency().symbol }}
                                {{
                                    Number(getFirstInvoiceAmount(service)).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li>                           
                            <li v-if="areThereInvoices(service) && getSecondInvoiceAmount(service) > 0">
                                Subsequent Invoices : {{ getCurrency().symbol }}
                                {{
                                    Number(getSecondInvoiceAmount(service)).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li>                            
                            <li>
                                Annualized Total : {{ getCurrency().symbol }}
                                {{
                                    Number(getPremiumBreakdownByPaymentFrequencyField(service, isVatApplied(service) ? 'totalPremiumWithTaxAndVat' : 'totalPremiumWithTax')).toLocaleString('en-GB', {
                                        minimumFractionDigits: 2,
                                    })
                                }}
                            </li>
                            <li></li>
                        </ul>
                    </div>

                    <div class="d-flex flex-column justify-content-between">
                        <div>
                            <div class="text-center form-section__field">
                                <span v-if="productData.mandatoryExcesses.length > 0">
                                    There is a mandatory excess of
                                    <span v-for="(item, index) in productData.mandatoryExcesses" :key="index">
                                        <span>
                                            {{ item }}
                                        </span>
                                    </span>
                                </span>
                                <br />
                                <span v-for="(item, index) in $root.t('step2.chooseAnExcess')" :key="index">
                                    {{ item }} <br />
                                </span>

                                <i
                                    class="fa fa-question-circle"
                                    aria-hidden="true"
                                    title="Description"
                                    @click="showExcessModal()"
                                />
                            </div>

                            <AppSelect
                                :id="'Product.Excess_' + index"
                                v-model="service.voluntarySelected"
                                :placeholder="$t('common.defaultSelectionValue')"
                                :options="selectLabelTranslation(service.voluntaryExcesses)"
                                key-value="value"
                                key-text="label"
                                class="form-section__field"
                                @input="voluntaryChange(service.voluntarySelected, service.voluntaryExcesses)"
                            />

                            <!-- CoInsurance -->
                            <div v-if="haveRenderBenefit(service, false)" class="form-section__field">
                                <div class="text-center">
                                    <span v-for="(item, index) in $root.t('step2.coInsurance')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                    <i
                                        class="fa fa-question-circle border-0"
                                        aria-hidden="true"
                                        data-bs-toggle="tooltip"
                                        title="Description"
                                        @click="showCoInsuranceHelper()"
                                    />
                                </div>

                                <div
                                    v-for="coInsure in getRenderCoInsures(service)"
                                    :key="coInsure.coInsureId"
                                    class="form-check mt-2"
                                    :class="coInsure.additionalClass"
                                >
                                    <label class="form-check-label" :for="'insurance_' + index + coInsure.coInsureId">
                                        <Input
                                            :id="'insurance_' + index + coInsure.coInsureId"
                                            v-model="coInsure.isSelected"
                                            class-name="form-check-input"
                                            input-type="radio"
                                            :name="index + coInsure.coInsureGroupId"
                                            :checked-value="true"
                                            @change.native="changeCoInsure(getBenefits(service, false), coInsure)"
                                        />
                                        <span>{{ coInsure.coInsureName }}.</span>
                                        <!-- <span v-if="currentLocale != 'en'">
                      <br>
                      {{ insurance.benefitNameTranslation }}
                    </span> -->
                                    </label>
                                </div>
                            </div>

                            <!-- Additional Benefits -->
                            <div v-if="haveRenderBenefit(service)" class="form-section__field">
                                <div class="text-center">
                                    <span v-for="(item, index) in $root.t('step2.additionalBenefits')" :key="index">
                                        {{ item }} <br />
                                    </span>
                                    <i
                                        class="fa fa-question-circle border-0"
                                        aria-hidden="true"
                                        title="Description"
                                        @click="showAdditionalBenefitModal()"
                                    />
                                </div>

                                <div
                                    v-for="benefit in getRenderBenefits(service)"
                                    :key="benefit.benefitID"
                                    class="form-check mt-2"
                                    :class="benefit.additionalClass"
                                >
                                    <Input
                                        :id="'addBenefit_' + index + benefit.benefitID"
                                        v-model="benefit.isSelected"
                                        class-name="form-check-input"
                                        :input-type="benefit.isRadio ? 'radio' : 'checkbox'"
                                        :name="'addBenefit_' + benefit.benefitGroupId"
                                        :checked-value="benefit.isRadio ? true : undefined"
                                        @change.native="changeBenefit(getBenefits(service), benefit)"
                                    />

                                    <label
                                        class="form-check-label"
                                        :for="'addBenefit_' + index + benefit.benefitID"
                                        v-html="benefit.benefitName + '.<br>' + benefit.benefitNameTranslation"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!print" class="mt-3 px-3">
                    <button
                        name="updateQuote"
                        class="btn btn-primary w-100"
                        style="font-size: 14px"
                        @click="updateQuote()"
                        v-html="$t('step2.updateQuoteBtn').replace('-', '<br>')"
                    />
                </div>

                <div v-if="!print" class="mt-3 px-3 row" role="list" :aria-label="$t('step2.getProductDocuments')">
                    <div v-for="(item, index) in $root.t('step2')" :key="index">
                        <a
                            class="me-3"
                            :href="getDocumentLinkByLevelOfCoverID(service.levelOfCoverID).IPID"
                            target="_blank"
                            style="font-size: 14px"
                            >{{ item.IPID }}</a
                        >
                        <br />
                        <a
                            :href="getDocumentLinkByLevelOfCoverID(service.levelOfCoverID).ToB"
                            target="_blank"
                            style="font-size: 14px"
                            >{{ item.ToB }}</a
                        >
                        <br /><br />
                    </div>
                </div>
            </li>
        </ul>

        <!-- Helper Modal -->
        <AppModal
            :title="helperTitle"
            :content="helperContent"
            :is-open="openHelperModal"
            @onClose="openHelperModal = false"
        />
    </div>
</template>
  
<script>
import AppSelect from '../shared/AppSelect.vue'
import AppModal from '../shared/Modal.vue'
import { getSummaryData } from '../../data/formData.js'

import applyOnlineService from '../../api/services/applyOnlineService'
import quickQuoteHandler from '../../api/services/quickQuoteHandler'

import productDocumentType from '../../api/common/constant/productDocumentType'

export default {
    name: 'EvolutionHealthPackage',
    components: {
        AppSelect,
        AppModal,
    },
    props: {
        productIndex: {
            type: Number,
            default: 0,
        },
        // print false thi ko update quote
        print: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        // ignore area not have package (validate package value)
        // this.validPackageValue()

        if (this.$formData.product.frequencyId === -1) {
            if (this.$quote.products[this.productIndex].paymentFrequencies[0]) {
                this.$formData.product.frequencyId =
                    this.$quote.products[this.productIndex].paymentFrequencies[0].paymentFrequencyID
            }
        }

        const product = this.$formData.product

        // Set default product at runtime if not area if formData
        if (this.$formData.product.areaId === -1) {
            product.areaId = this.$quote.products[this.productIndex].areasOfCover[0].areaOfCoverID
        }

        if (this.$formData.product.levelOfCoverId === -1) {
            product.levelOfCoverId =
                this.$quote.products[this.productIndex].areasOfCover[0].levelsOfCover[0].levelOfCoverID
        }

        return {
            product: product,
            helperModel: null,
            helperTitle: '',
            helperContent: '',
            openHelperModal: false,

            voluntarySelectedId: -1,
            // currencySymbol: '',
            // currencyCode: '',

            duplicateBenefit: '',

            summary: getSummaryData(this),

            productDocumentType: productDocumentType,

            productDocuments: [],
            benefitExclusions: [],
            currentLocale: this.$locale,
        }
    },
    computed: {
        productData() {
            return this.$quote.products[this.productIndex]
        },
        areaIndex() {
            return this.productData.areasOfCover.findIndex((i) => i.areaOfCoverID === this.product.areaId)
        },
        productAreas() {
            // Premiums will not be calculated for invalid areas of cover for a country of residence.
            // Return areas where invalidAreaOfCoverForCountryOfResidence = false
            return this.productData.areasOfCover.filter(
                (areaOfCover) => areaOfCover.invalidAreaOfCoverForCountryOfResidence === false,
            )
        },
        levelOfCoverIndex() {
            return this.levelsOfCover.findIndex((i) => i.levelOfCoverID === this.product.levelOfCoverId)
        },
        levelsOfCover() {
            return this.productAreas[this.areaIndex].levelsOfCover
        },
        voluntarySelected(voluntaryExcesses) {
            var voluntaries = voluntaryExcesses.voluntaryExcesses
            var voluntary = voluntaries.find((v) => v.isSelected)
            if (!voluntary) {
                voluntary = voluntaryExcesses[0]
                voluntary.isSelected = true
            }

            return voluntary
        },
        requestedCurrencyUnavailableForProduct() {
            let selectedProductCurrencyId = this.$quote.products[this.productIndex].currencies.find(
                (v) => v.isSelected === true,
            ).currencyID
            return this.$quote.currency.currencyID !== selectedProductCurrencyId
        },

        coInsuranceName() {
            return this.$t('step2.coInsurance').toLowerCase()
        },

        coInsuranceDefaultName() {
            return this.$t('step2.coInsuranceDefault').toLowerCase()
        },
    },
    watch: {
        productIndex() {
            this.selectArea(0)
            // this.getCurrencyCode(this.productData)

            // set default frequency
            if (this.productData.paymentFrequencies.length) {
                this.product.frequencyId = this.productData.paymentFrequencies[0].paymentFrequencyID
            } else {
                this.product.frequencyId = -1
            }

            this.initProductDocuments()
        },
    },
    mounted() {
        let productSelected = this.$quote.products[this.productIndex]
        let areaIndex = productSelected.areasOfCover.findIndex((i) => i.areaOfCoverID === this.product.areaId)
        this.setDefaultVoluntary(areaIndex)
        this.setDefaultBenefit(productSelected, areaIndex)
        this.setDefaultCoInsurance(productSelected, areaIndex)
        this.initProductDocuments()
    },
    methods: {
        initRenderBenefitByLOC(loc, isBenefit) {
            isBenefit ? quickQuoteHandler.renderBenefits(loc) : quickQuoteHandler.renderCoInsures(loc)
        },

        /**
         * Get render coInsure data
         */
        getRenderCoInsures(loc) {
            const coInsuresForDisplay = new Map()
            let coInsures = loc.coInsures || []

            if (loc.coInsures.length) {
                coInsures.forEach((element) => {
                    if (!coInsuresForDisplay.has(element.coInsureName)) {
                        coInsuresForDisplay.set(element.coInsureName, element)
                    }
                })

                coInsures = Array.from(coInsuresForDisplay.values()).sort(
                    (a, b) => a.coInsureDisplayOrderBy - b.coInsureDisplayOrderBy,
                )
            }

            return coInsures
        },

        /**
         * Get render benefit data
         */
        getRenderBenefits(loc) {
            const benefitsForDisplay = new Map()
            let benefits = loc.benefits || []

            if (loc.benefits.length) {
                benefits.forEach((element) => {
                    if (!benefitsForDisplay.has(element.benefitName)) {
                        benefitsForDisplay.set(element.benefitName, element)
                    }
                })

                benefits = Array.from(benefitsForDisplay.values()).sort(
                    (a, b) => a.benefitDisplayOrderBy - b.benefitDisplayOrderBy,
                )
            }

            return benefits
        },

        /**
         * Check DOM is radio or check box (by benefit data)
         */
        haveRenderBenefit(loc, benefit = true) {
            this.initRenderBenefitByLOC(loc, benefit)
            return benefit ? loc.benefits.length > 0 : loc.coInsures.length > 0
        },

        /**
         * Initial product documents (IPID, Tob, PoW, ...etc)
         */
        initProductDocuments() {
            const levelOfCoverIds = []
            this.productAreas.forEach((area) => {
                this.productDocuments = []
                area.levelsOfCover.forEach((levelOfCoverItem) => {
                    if (levelOfCoverIds.indexOf(levelOfCoverItem.levelOfCoverID) < 0) {
                        levelOfCoverIds.push(levelOfCoverItem.levelOfCoverID)
                    }
                })
            })

            levelOfCoverIds.forEach((id) => {
                Promise.all([
                    this.getProductDocument(productDocumentType.IPID, id),
                    this.getProductDocument(productDocumentType.ToB, id),
                ]).then(([IPID, ToB]) => {
                    this.productDocuments.push({
                        levelOfCoverID: id,
                        IPID: IPID.fileUrl || '',
                        ToB: ToB.fileUrl || '',
                    })
                })
            })

            this.$forceUpdate()
        },

        async getProductDocument(docType, levelOfCover) {
            const lang = applyOnlineService.getLanguageByCountry(
                this.$optionData,
                this.$formData.policyHolder.details.residenceCountryId,
                this.$formData.policyHolder.details.nationalityCountryId,
            )

            const product = this.$formData.product

            try {
                const result = await applyOnlineService.getProductDocumentsAsync(
                    product.productId,
                    product.areaId,
                    levelOfCover,
                    this.$formData.policyDetails.policyStartDate,
                    lang,
                    docType,
                    false,
                    this.$productDocuments,
                )

                return result
            } catch (error) {
                return ''
            }
        },

        getDocumentLinkByLevelOfCoverID(levelOfCoverID) {
            const doc = this.productDocuments.find((i) => i.levelOfCoverID == levelOfCoverID)
            if (doc) {
                return doc
            }
            return {}
        },

        updateQuote() {
            var updateBtns = document.getElementsByName('updateQuote')
            try {
                const self = this
                updateBtns.forEach((el) => {
                    el.disabled = true
                })
                self.$emit('update-quote-event', () => {
                    updateBtns.forEach((el) => {
                        el.disabled = false
                    })
                })
            } catch (error) {
                // updateBtns.forEach((el) => {
                //   el.disabled = false
                // })
            }
        },

        setDefaultVoluntary(areaIndex) {
            let productSelected = this.$quote.products[this.productIndex]
            let area = productSelected.areasOfCover[areaIndex]
            area.levelsOfCover.forEach((lvl) => {
                if (lvl.voluntaryExcesses != null && lvl.voluntaryExcesses.length > 0) {
                    var selectedVoluntary = lvl.voluntaryExcesses.find((v) => v.isSelected === true)
                    // get current select
                    if (selectedVoluntary) {
                        lvl.voluntarySelected = selectedVoluntary.voluntaryExcessID
                    } else {
                        // select default: first item in list voluntaries
                        lvl.voluntarySelected = lvl.voluntaryExcesses[0].voluntaryExcessID
                        lvl.voluntaryExcesses[0].isSelected = true
                    }
                }
            })

            this.$forceUpdate()
        },

        /**
         * Set default selected for benefit have `benefitDefault = true`
         */
        setDefaultBenefit(productSelected, areaIndex) {
            let area = productSelected.areasOfCover[areaIndex]
            area.levelsOfCover.forEach((lvl) => {
                if (
                    lvl.benefits != null &&
                    lvl.benefits.length > 0 &&
                    lvl.benefits.findIndex((v) => v.isSelected) < 0
                ) {
                    const selectedBenefits = lvl.benefits.filter((v) => v.benefitDefault && !v.isSelected)
                    selectedBenefits.forEach((benefit) => {
                        benefit.isSelected = benefit.benefitDefault
                    })
                }
            })
        },

        /**
         * Set default selected for coInsure have `coInsureDefault = true`
         */
        setDefaultCoInsurance(productSelected, areaIndex) {
            let area = productSelected.areasOfCover[areaIndex]
            area.levelsOfCover.forEach((lvl) => {
                // Just set default select for coInsures on the first render (all data have isSelected = false)
                if (
                    lvl.coInsures != null &&
                    lvl.coInsures.length > 0 &&
                    lvl.coInsures.findIndex((v) => v.isSelected) < 0
                ) {
                    const selectedCoInsures = lvl.coInsures.filter((v) => v.coInsureDefault)
                    if (selectedCoInsures.length) {
                        selectedCoInsures.forEach((coInsure) => {
                            coInsure.isSelected = coInsure.coInsureDefault
                        })
                    }
                }
            })
        },

        voluntaryChange(voluntarySelected, voluntaryExcesses) {
            var voluntary = voluntaryExcesses.find((v) => v.voluntaryExcessID == voluntarySelected)
            if (voluntary) {
                voluntaryExcesses.forEach((vol) => {
                    vol.isSelected = false
                })

                voluntary.isSelected = true
            }
        },

        selectArea(index, areaId = -1) {
            if (areaId !== -1) {
                this.$formData.product.areaId = areaId
            }

            this.product.areaId = this.productAreas[index].areaOfCoverID
            // Reset levelOfCover to 0
            this.selectLevelOfCover(0)
            this.setDefaultVoluntary(index)

            let productSelected = this.$quote.products[this.productIndex]

            this.setDefaultBenefit(productSelected, index)
            this.setDefaultCoInsurance(productSelected, index)
        },

        selectLevelOfCover(index) {
            this.product.levelOfCoverId = this.levelsOfCover[index].levelOfCoverID
        },

        selectFrenquency(frequencyId, frequencyItem) {
            this.product.paymentFrequencyName = frequencyItem.paymentFrequencyName
            this.product.paymentFrequencyNameTranslation = frequencyItem.paymentFrequencyNameTranslation
            this.product.frequencyId = frequencyId
        },

        changeCoInsure(coInsures, coInsureDisplay) {
            coInsures.forEach((coInsure) => {
                if (coInsure.coInsureName == coInsureDisplay.coInsureName) {
                    coInsure.isSelected = coInsureDisplay.isSelected
                }

                if (
                    coInsure.coInsureName !== coInsureDisplay.coInsureName &&
                    coInsure.coInsureGroupId !== '' &&
                    coInsure.coInsureGroupId === coInsureDisplay.coInsureGroupId
                ) {
                    coInsure.isSelected = false
                }
            })
        },

        changeBenefit(benefits, benefitDisplay) {
            benefits.forEach((benefit) => {
                if (benefit.benefitName == benefitDisplay.benefitName) {
                    benefit.isSelected = benefitDisplay.isSelected
                }

                if (
                    benefit.benefitName !== benefitDisplay.benefitName &&
                    benefit.benefitGroupId !== '' &&
                    benefit.benefitGroupId === benefitDisplay.benefitGroupId
                ) {
                    benefit.isSelected = false
                }
            })
        },

        getCurrency() {
            const currency = {
                code: '',
                symbol: '',
            }

            if (this.productData.currencies.length) {
                const productCurrency = this.productData.currencies.find((v) => v.isSelected)
                currency.code = productCurrency.currencyCode
                currency.symbol = productCurrency.currencySymbol
            }

            return currency
        },

        getPremium(paymentFrequency) {
            let item = paymentFrequency.find((pf) => pf.paymentFrequencyID == this.product.frequencyId)

            let premium = ''

            if (item)
            {
                premium = item.paymentFrequencyEx.basePremiumDividedByPaymentFrequencyAmount
            }

            return premium
        },

        getMandatory(paymentFrequency) {
            let item = paymentFrequency.find((pf) => pf.paymentFrequencyID == this.product.frequencyId)

            return item.mandatoryExcesses
        },

        getPremiumEx(service, field) {
            let item = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )

            let fieldValue = ''

            if (item.paymentFrequencyEx && field in item.paymentFrequencyEx) {
                fieldValue = item.paymentFrequencyEx[field]
            }

            return fieldValue
        },

        getPremiumBreakdownByPaymentFrequencyField(service, field) {            
            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )

            return premiumBreakdown[field]
        },

        areThereInvoices(service) {
            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )

            return premiumBreakdown.invoices.length > 0
        },

        getFirstInvoiceAmount(service) {
            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )

            if (premiumBreakdown.invoices.length == 0) {
                return 0
            }

            return premiumBreakdown.invoices[0].amount
        },

        getSecondInvoiceAmount(service) {
            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )

            if (premiumBreakdown.invoices.length <= 1) {
                return 0
            }

            return premiumBreakdown.invoices[1].amount
        },

        isVatApplied(service) {
            let vatApplied = false

            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )
            premiumBreakdown.taxesApplied.forEach((tax, index, array) => {
                if (tax.key.taxTypeShortName.toLowerCase() === 'vat') {
                    vatApplied = true
                }
            })

            return vatApplied;
        },

        isVatTheOnlyTaxApplied(service) {
            let vatTheOnlyTaxApplied = false
            let vatTaxCount = 0

            let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
                (pf) => pf.paymentFrequencyID == this.product.frequencyId,
            )
            premiumBreakdown.taxesApplied.forEach((tax, index, array) => {
                if (tax.key.taxTypeShortName.toLowerCase() === 'vat') {
                    vatTheOnlyTaxApplied = true
                    vatTaxCount = vatTaxCount + 1
                }
            })

            if (vatTaxCount > 0) {
                vatTheOnlyTaxApplied = premiumBreakdown.taxesApplied.length == vatTaxCount
            }

            return vatTheOnlyTaxApplied;
        },

        // getAnnualVatAmount(service) {
        //     let vatAmount = 0

        //     let premiumBreakdown = service.premiumsAsPerPaymentFrequency.premiumBreakdownByPaymentFrequency.find(
        //         (pf) => pf.paymentFrequencyID == this.product.frequencyId,
        //     )
        //     premiumBreakdown.taxesApplied.forEach((tax, index, array) => {
        //         if (tax.key.taxTypeShortName.toLowerCase() === 'vat') {
        //             vatAmount = vatAmount + tax.value
        //         }
        //     })
            
        //     return vatAmount
        // },

        /**
         * Get Benefits (coInsurance or additionalBenefits) by isRadio field: true - coInsurance || false - additionalBenefits
         */
        getBenefits(loc, isBenefit = true) {
            return isBenefit ? loc.benefits : loc.coInsures
        },

        showCoInsuranceHelper() {
            this.helperTitle = this.$root.t('popup.coInsurance')
            this.helperContent = this.$root.t('popup.coInsuranceContent')
            this.openHelperModal = true
        },

        showPaymentFrequency() {
            this.helperTitle = this.$root.t('popup.paymentTitle')
            this.helperContent = this.$root.t('popup.paymentFrequencyContent')
            this.openHelperModal = true
        },

        showExcessModal() {
            this.helperTitle = this.$root.t('popup.excess')
            this.helperContent = this.$root.t('popup.excessContent')
            this.openHelperModal = true
        },

        showAdditionalBenefitModal() {
            if (this.$formData.selectedProductIndex < 0) { return }
            
            switch(this.$quote.products[this.$formData.selectedProductIndex].productName.toLowerCase())
            {
                case 'evolution health asia pacific':
                case 'evolution health asia pacific hst':
                case 'evolution health eu and eea':
                case 'evolution (uk/gib/iom)':
                case 'evolution health rest of world':
                    {
                        this.helperContent = this.$root.t('popup.homeEvacBenefitWording')
                        break;
                    }
                case 'flexible choices asia':
                    {
                        this.helperContent = this.$root.t('popup.flexibleChoicesBenefitWording')
                        break;
                    }
                default:
                    {
                        return;
                    }
            }
            this.helperTitle = this.$root.t('popup.benefit')
            this.openHelperModal = true
        },

        getAreaPrint() {
            return this.summary.areaSelected.areaOfCoverName
        },

        getFrequencyPrint() {
            return this.summary.frequencySelected.paymentFrequencyName
        },

        selectLabelTranslation(options) {
            return options.map((item) => {
                return {
                    value: item['voluntaryExcessID'],
                    label:
                        this.$locale == 'en'
                            ? item['voluntaryExcessName']
                            : item['voluntaryExcessName'] + ' - ' + item['voluntaryExcessNameTranslation'],
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.service-price {
    font-size: 1.5rem;
    font-weight: bold;
}

.service-item {
    cursor: pointer;
    min-width: 227px;
    margin-bottom: 170px;
    max-width: 227px;

    &:hover:not(.active) {
        box-shadow: 1px 0px 10px 0px rgba(0, 0, 0, 0.5);
    }

    &.active {
        border: 1px solid var(--mp-blue);
        transform: scale(1.1);
    }
}

.btn-primary {
    color: #fff;
    background-color: #0a58ca;
    border-color: #0a58ca;
}
</style>
  